import './mobile-nav.scss';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Menu } from '../menu';
import { SocialLinks } from '../social-links';

const socials = [
  {
    id: 0,
    linkClassName: 'btn-facebook',
    url: 'https://www.facebook.com/agentfiresites/',
    iconClassName: 'facebook',
    text: 'Facebook',
  },
  {
    id: 1,
    linkClassName: 'btn-youtube',
    url: 'https://www.youtube.com/channel/UCNCf98ejnJDRaoHr5HCu5BA',
    iconClassName: 'youtube',
    text: 'Youtube',
  },
];

const MobileNav = (props) => {
  const { items, isOpen, toggleNav } = props;
  return (
    <div className={isOpen ? 'mobile-nav-overlay mobile-nav-open' : 'mobile-nav-overlay'} onClick={toggleNav}>
      <div className={isOpen ? 'mobile-nav mobile-nav-open' : 'mobile-nav'}>
        <p className="mobile-nav-title">Menu</p>
        <ul className="mobile-nav-menu d-block d-md-none align-center">
          <Menu items={items} isMobile />
        </ul>
      </div>
      <SocialLinks
        className="mobile-nav-footer"
        iconClassName="btn-social-icon-compass"
        iconTypeClassName="fab"
        linkClassName="btn-social-link"
        textClassName="btn-social-text"
        showText={false}
        target="_blank"
        items={socials}
      />
    </div>
  );
};

MobileNav.propTypes = {
  items: PropTypes.array,
  toggleNav: PropTypes.func,
  isOpen: PropTypes.bool,
};

MobileNav.defaultProps = {
  items: [],
  toggleNav: () => {},
  isOpen: false,
};

export default memo(MobileNav);
